import 'mdn-polyfills/Element.prototype.classList';
import 'mdn-polyfills/Node.prototype.remove';
import 'intersection-observer';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { enableES5 } from 'immer';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { preloadChunks } from 'app/libs/lazyload';
import Root from 'app/client/Root';
import mobileAppBridge from 'app/libs/MobileAppBridge';
import { initSentry } from 'app/libs/sentry';
import reportWebVitals from './reportWebVitals';

enableES5();

global.mobileAppBridge = mobileAppBridge;

const sentryDsnCheck = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsnCheck !== '' && sentryDsnCheck !== undefined) {
	initSentry();
}

const wrap = document.getElementById('wrap');

if (process.env.NODE_ENV === 'production') {
	// eslint-disable-next-line no-underscore-dangle
	preloadChunks(global.__SSR_CHUNKS__ || []).then(() => {
		hydrateRoot(wrap, <Root />, { onRecoverableError: () => console.log('onRecoverableError') });
	});
} else {
	const root = createRoot(wrap);
	root.render(<Root />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
